// File: frontend/src/components/ThemeToggle.jsx

import React from 'react';
import { useTheme } from '../ThemeContext';

export default function ThemeToggle({ className = '' }) {
    const { theme, toggleTheme } = useTheme();

    return (
        <button
            type="button"
            onClick={toggleTheme}
            className={`inline-flex items-center justify-center w-8 h-8 rounded-lg bg-black/20 backdrop-blur-xs border border-white/20 text-white hover:bg-black/30 transition-colors cursor-pointer ${className}`}
            title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
        >
            <span className="text-sm leading-none">{theme === 'dark' ? '☀️' : '🌙'}</span>
        </button>
    );
}
